exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-quantity[data-v-be88772e] {\n  position: relative;\n}\n.product-quantity[data-v-be88772e] .spinner {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n", ""]);

// exports
